import { render, staticRenderFns } from "./SitchShopItemPage.vue?vue&type=template&id=e1717b2e&scoped=true&"
import script from "./SitchShopItemPage.vue?vue&type=script&lang=ts&"
export * from "./SitchShopItemPage.vue?vue&type=script&lang=ts&"
import style0 from "./SitchShopItemPage.vue?vue&type=style&index=0&id=e1717b2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1717b2e",
  null
  
)

export default component.exports